import React from 'react'

const IconData = (props) => {
  return (
    <svg {...props} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.2 12.8C29.147 12.8 36.4 10.3823 36.4 7.4C36.4 4.41766 29.147 2 20.2 2C11.253 2 4 4.41766 4 7.4C4 10.3823 11.253 12.8 20.2 12.8Z" stroke="currentcolor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M36.4 19.9998C36.4 22.9878 29.2 25.3998 20.2 25.3998C11.2 25.3998 4 22.9878 4 19.9998" stroke="currentcolor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M4 7.3999V32.5999C4 35.5879 11.2 37.9999 20.2 37.9999C29.2 37.9999 36.4 35.5879 36.4 32.5999V7.3999" stroke="currentcolor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default IconData